import { useGetUsersQuery } from "./usersApiSlice"
import User from './User'
import useTitle from "../../hooks/useTitle"
import {Spinner} from 'react-bootstrap'

const UsersList = () => {
    useTitle('Nirakar Satguru: Users List')

    const {
        data: users,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUsersQuery('usersList', {
        pollingInterval: 60000,
        refetchOnFocus: false,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <Spinner color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {

        const { ids } = users

        const tableContent = ids?.length && ids.map(userId => <User key={userId} userId={userId} />)

        content = (
            <><h2 className="pageHeading">User List</h2>
            <table className="table table--users">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th user__username">Name</th>
                        <th scope="col" className="table__th user__email">Email</th>
                        <th scope="col" className="table__th user__mobile">Mobile</th>
                        <th scope="col" className="table__th user__roles">Roles</th>
                        <th scope="col" className="table__th user__membership-tier">Membership Tier</th>
                        <th scope="col" className="table__th user__membership-status">Membership Status</th>
                        <th scope="col" className="table__th user__sponsored">Sponsored Member</th>
                        <th scope="col" className="table__th user__block-status">Block Status</th> {/* ✅ नया कॉलम */}
                        <th scope="col" className="table__th user__edit">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table></>
        )
    }

    return content
}
export default UsersList
